document.addEventListener('DOMContentLoaded', function () {
  // Only run on product pages
  if (!window.location.pathname.startsWith('/products/')) {
    return;
  }

  // Get the current product handle
  const productHandle = window.location.pathname
    .split('/products/')[1]
    .split('/')[0];

  if (!productHandle) {
    return;
  }

  // Find all Contact Us links pointing to the contact page
  const contactLinks = document.querySelectorAll(
    'a[href*="/pages/contact"]'
  );

  contactLinks.forEach(function (link) {
    link.href = '/pages/contact?product=' + encodeURIComponent(productHandle);
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const productHandle = params.get('product');

  if (!productHandle) return;

  fetch('/products/' + encodeURIComponent(productHandle) + '.js')
    .then(response => response.json())
    .then(product => {
      document.getElementById('ContactForm-product').value = product.title;
      document.getElementById('ContactForm-product-url').value =
        window.location.origin + '/products/' + product.handle;
    });
});

 jQuery(document).ready(function($) {
      jQuery('#homeslider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });

    
});

document.addEventListener('cart:refresh', function (event) {
  if (!event.detail || !event.detail.cart) return;

  const count = event.detail.cart.item_count;

  document.querySelectorAll('.cart-count-number').forEach(el => {
    el.textContent = count;
  });

  document.querySelectorAll('.cart-count-bubble').forEach(el => {
    el.classList.toggle('hidden', count === 0);
  });
});

// Trigger after add/remove
function refreshCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      document.dispatchEvent(
        new CustomEvent('cart:refresh', { detail: { cart } })
      );
    });
}


const searchInput = document.getElementById('HeaderSearchInput');
const resultsBox = document.getElementById('predictive-search-results');

if (searchInput) {
  let controller;

  searchInput.addEventListener('input', function () {
    const query = this.value.trim();

    if (query.length < 2) {
      resultsBox.innerHTML = '';
      resultsBox.style.display = 'none';
      return;
    }

    if (controller) controller.abort();
    controller = new AbortController();

   fetch(
  `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=20`,
  {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    },
    signal: controller.signal
  }
)

  .then(res => res.json())
  .then(data => {
    const products = data.resources.results.products;
    if (!products.length) {
      resultsBox.style.display = 'none';
      return;
    }

    resultsBox.innerHTML = `
      <ul>
        ${products.map(product => `
          <li>
            <a href="${product.url}">
              ${product.image ? `<img src="${product.image}" alt="">` : ''}
              <span>${product.title}</span>
            </a>
          </li>
        `).join('')}
      </ul>
    `;
    resultsBox.style.display = 'block';
  })
  .catch(err => {
    // 🔥 IMPORTANT FIX
    if (err.name === 'AbortError') return;
    console.error(err);
  });

  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.header-search')) {
      resultsBox.style.display = 'none';
    }
  });
}



 document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('.menu-dropdown__button');
    const dropdown = document.querySelector('.menu-dropdown');

    if (!button) return;

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      dropdown.classList.toggle('active');
      button.setAttribute(
        'aria-expanded',
        dropdown.classList.contains('active')
      );
    });

    document.addEventListener('click', () => {
      dropdown.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
    });
  });

jQuery(document).ready(function($) {
  $('.template-collection #verticalTitle').text('Filter');
});
 
document.querySelectorAll('.accordion-title').forEach(title => {
  // Create an img element for the arrow if not already present
  let arrow = title.querySelector('img');
  if (!arrow) {
    arrow = document.createElement('img');
    arrow.src = "https://cdn.shopify.com/s/files/1/0758/2164/6142/files/down.svg?v=1770204222"; // default down arrow
    arrow.alt = "Toggle";
    arrow.classList.add('accordion-arrow');
    arrow.style.marginLeft = "10px"; // optional spacing
    title.appendChild(arrow);
  }

  title.addEventListener('click', () => {
    const item = title.closest('.accordion-item');
    const content = title.nextElementSibling;

    // Close all other items
    document.querySelectorAll('.accordion-item').forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.classList.remove('active');
        otherItem.querySelector('.accordion-content').style.display = 'none';
        const otherArrow = otherItem.querySelector('.accordion-title img');
        if (otherArrow) {
          otherArrow.src = "https://cdn.shopify.com/s/files/1/0758/2164/6142/files/down.svg?v=1770204222";
        }
      }
    });

    // Toggle clicked item
    const isActive = item.classList.toggle('active');
    content.style.display = isActive ? 'block' : 'none';
    arrow.src = isActive
      ? "https://cdn.shopify.com/s/files/1/0758/2164/6142/files/up.svg?v=1770204223"   // open state
      : "https://cdn.shopify.com/s/files/1/0758/2164/6142/files/down.svg?v=1770204222"; // closed state
  });
});



document.addEventListener("click", function (e) {
  const btn = e.target.closest(".faq-question");
  if (!btn) return;

  btn.classList.toggle("active");

  const icon = btn.querySelector(".faq-icon");
  icon.textContent = btn.classList.contains("active") ? "−" : "+";

  const answer = btn.nextElementSibling;
  answer.classList.toggle("open");
});
  document.addEventListener("DOMContentLoaded", function() {
    // When any pagination link is clicked
    document.querySelectorAll(".pagination a").forEach(function(link) {
      link.addEventListener("click", function(e) {
        // Wait for page to load then scroll
        setTimeout(function() {
          document.querySelector(".shopping").scrollIntoView({
            behavior: "smooth"
          });
        }, 100);
      });
    });
  });


    $(document).ready(function() {
    $('.our-values__card').hover(
      function() {
        // Mouse enters: add active class
        $(this).addClass('active');
      },
      function() {
        // Mouse leaves: remove active class
        $(this).removeClass('active');
      }
    );
  });


  var objct = $(".mw-apo-container").closest('.quantity-carts').addClass('yourClass');
  $(document).on("click",".custom_img_product",function() {
    // alert('fvc');
    $('.custom_popupp').css('display', 'block')
    $("body.gradient").addClass('popup_overlay');
    $( ".slick-next" ).trigger( "click" );
    
});

 $(".popup_close_btn span").click(function(){
    // alert('dsd');
     $('.custom_popupp').css('display', 'none')
    $("body.gradient").removeClass('popup_overlay');
    });


    